import { Store } from '../types'
import { Context } from './types'

export const contextSelector = (store: Store) => store.context as Context
